/** Compact page typography shared by Admin, League, and similar views. */

export const PAGE_MAX_W = 'min(960px, 100%)';

export const pageTitleProps = {
  fontSize: 'lg',
  fontWeight: 'semibold',
  as: 'h1' as const,
};

export const pageSubtitleProps = {
  fontSize: 'sm',
  color: 'gray.500',
};

export const pageSectionTitleProps = {
  fontSize: 'sm',
  fontWeight: 'semibold',
  as: 'h2' as const,
};

export const pageBodyTextProps = {
  fontSize: 'sm',
};

export const pageMetaTextProps = {
  fontSize: 'xs',
  color: 'gray.500',
};

export const pageButtonProps = {
  size: 'sm' as const,
};

export const pageTabListProps = {
  size: 'sm' as const,
};
